// ABOUTME: Microsoft Clarity integration for session recording and heatmaps.
// ABOUTME: Initializes Clarity only when VITE_CLARITY_ID is set.

import config from "@/config"
import { foreignServicesAllowed } from "./domain"

/** The Clarity tag: a queue-collecting stub until the script loads, then the real API */
type ClarityFn = ((...args: unknown[]) => void) & { q?: unknown[] }

declare global {
  interface Window {
    clarity?: ClarityFn
  }
}

export const initClarity = (): void => {
  const clarityId = config.CLARITY_ID
  if (!clarityId || !foreignServicesAllowed()) return

  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.clarity.ms/tag/${clarityId}`
  document.head.appendChild(script)

  // Initialize clarity queue
  if (!window.clarity) {
    const stub: ClarityFn = (...args: unknown[]) => {
      stub.q = stub.q || []
      stub.q.push(args)
    }
    window.clarity = stub
  }
}
